import { Shape } from 'three';

/**
 * A-31713 Almag floor plank profile: 6" wide x 2" tall (ADJ-02).
 * Real Go Rampe C-channel sections are ~3.5" thick; 2" is a pragmatic visual
 * improvement without a full C-channel composition refactor.
 * SOLID profile — rib detail comes from normalMap texture, not through-holes.
 * Coordinates in inches (will be scaled by SCALE_IN_TO_UNIT at extrude time).
 */
export function floorPlankProfile(): Shape {
  const s = new Shape();
  s.moveTo(-3, 0);
  s.lineTo(3, 0);
  s.lineTo(3, 2); // CHANGE: was 1, now 2 (2" thick section visible from side)
  s.lineTo(-3, 2); // CHANGE
  s.closePath();
  return s;
}

/**
 * MTC120125125: 1.25" x 1.25" square tube, 0.120" wall.
 */
export function squareTubeProfile(): Shape {
  const s = new Shape();
  s.moveTo(-0.625, -0.625);
  s.lineTo(0.625, -0.625);
  s.lineTo(0.625, 0.625);
  s.lineTo(-0.625, 0.625);
  s.closePath();
  const hole = new Shape();
  hole.moveTo(-0.505, -0.505);
  hole.lineTo(0.505, -0.505);
  hole.lineTo(0.505, 0.505);
  hole.lineTo(-0.505, 0.505);
  hole.closePath();
  s.holes.push(hole);
  return s;
}

/**
 * MTR065075031: 0.75" OD round tube, 0.065" wall.
 * Approximated as polygon (default 24 segments) for ExtrudeGeometry.
 */
export function roundTubeProfile(segments = 24): Shape {
  const s = new Shape();
  const rOuter = 0.375;
  const rInner = 0.31;
  s.moveTo(rOuter, 0);
  for (let i = 1; i <= segments; i++) {
    const a = (i / segments) * Math.PI * 2;
    s.lineTo(Math.cos(a) * rOuter, Math.sin(a) * rOuter);
  }
  const hole = new Shape();
  hole.moveTo(rInner, 0);
  for (let i = 1; i <= segments; i++) {
    const a = (i / segments) * Math.PI * 2;
    hole.lineTo(Math.cos(a) * rInner, Math.sin(a) * rInner);
  }
  s.holes.push(hole);
  return s;
}
